import classNames from "classnames";
import styles from "./AscPostPreview.module.scss";
import AscAdminAction from "../AscAdminAction/AscAdminAction";
import { MoreIcon } from "../AscIcons";
import { useOutsideClick } from "@ascendnow/shared";
export interface AscPostPreviewProps {
  className?: string;
  image?: string | JSX.Element;
  title?: string;
  status?: string;
  text?: string;
  authorImage?: string | JSX.Element;
  authorName?: string;
  time?: string;
  onClick?: () => void;
  onEdit?: () => void;
  onRemove?: () => void;
}

export default function AscPostPreview({
  className,
  image,
  title,
  status,
  text,
  authorImage,
  authorName,
  onEdit,
  onRemove,
  time,
}: AscPostPreviewProps) {
  const { ref, isVisible, setIsVisible } =
    useOutsideClick<HTMLDivElement>(false);

  return (
    <div
      data-testid="asc-post-preview"
      className={classNames(styles.ground, className)}
    >
      {image ? (
        <div className={styles.postImage}>{image}</div>
      ) : (
        <div className={styles.noImage} />
      )}

      <div className={styles.rightGround}>
        <div className={styles.top}>
          {title}
          <span
            className={classNames(styles.status, {
              [styles.competition]: status?.toLowerCase() === "competition",
              [styles.update]: status?.toLowerCase() === "update",
              [styles.webinar]: status?.toLowerCase() === "webinar",
            })}
          >
            {status}
          </span>
        </div>

        <div className={styles.middle}>
          {text && <p dangerouslySetInnerHTML={{ __html: text }}></p>}
        </div>

        <div className={styles.bottom}>
          {authorImage ? (
            <div className={styles.authorImage}>{authorImage}</div>
          ) : (
            <div className={styles.noAuthorImg} />
          )}

          <span className={styles.authorName}>By {authorName}</span>
          <div className={styles.dot} />
          <span className={styles.time}>{time}</span>
          <MoreIcon
            className={styles.icon}
            onClick={() => setIsVisible(!isVisible)}
          />
          <div ref={ref}>
            {isVisible && (
              <AscAdminAction
                option1={"Edit"}
                option2={"Remove"}
                clickOption1={onEdit}
                clickOption2={onRemove}
                className={styles.actionBar}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
